import moment from "moment";
import React, {
  useMemo,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { useSelector } from "react-redux";
import { converteHorarioRodada } from "src/loteria/utils/extracaoUtils";

import "src/styles/date-selector.scss";

const DateSelector = ({ selectedContest, handleChange }) => {
  const objConcursos = useSelector(
    (state) => state.usuario.objUser.objConcursos
  );

  const contestConfig = objConcursos.arrConcursosGame.find(
    (e) => e.sntTipojogo === selectedContest.objTipoJogo.sntTipoJogo
  );
  const allowsContestSelection = contestConfig && contestConfig.tnyTipoInputRodadaConcursoWeb === 0;

  const timeout = useRef(null);
  const [selected, setSeleted] = useState([]);
  const [isTypeDate, setIsTypeDate] = useState(false);
  const [currentMoment, setCurrentMoment] = useState(moment());
  const [value, setValue] = useState(0);

  useEffect(() => {
    const time =
      (60 - new Date().getSeconds()) * 1000 - new Date().getMilliseconds();

    timeout.current = setTimeout(() => {
      checkIfDataIsAvailable(selected);
      setCurrentMoment(moment());
      setSeleted((state) => [].concat(state));
    }, time);

    return () => {
      clearTimeout(timeout.current);
    };
  }, [selected]);
  
  const arrContestTimes = useMemo(() => {
    const arrSorteio = (contestConfig && contestConfig.arrConcursoSorteio) || [];

    return arrSorteio.map(sorteio => ({
      label: converteHorarioRodada(sorteio.intHorarioRodada),
      value: sorteio.ConcursoData_ID
    }))
  }, [contestConfig]);

  const arrDatas = useMemo(() => {
    const datas = [];

    const arrConcursoData = objConcursos.arrConcursos.filter(
      (e) => e.sntTipojogo === selectedContest.objTipoJogo.sntTipoJogo
    );
    const arrConcursoSorteio = objConcursos.arrConcursosGame.filter(
      (e) => e.sntTipojogo === selectedContest.objTipoJogo.sntTipoJogo
    );

    if (arrConcursoSorteio && arrConcursoSorteio.length > 0) {
      setIsTypeDate(false);
      const arrSorteio = arrConcursoSorteio[0].arrConcursoSorteio;

      for (const sorteio of arrSorteio) {
        const horaRodada = converteHorarioRodada(sorteio.intHorarioRodada);

        if (
          moment(
            moment(moment().format("YYYY-MM-DD") + " " + horaRodada)
          ).isAfter(moment())
        ) {
          datas.push({
            value: sorteio.ConcursoData_ID,
            label: horaRodada,
          });
        }
      }
    } else if (arrConcursoData && arrConcursoData.length > 0) {
      setIsTypeDate(true);
      //Se for concurso
      for (const concurso of arrConcursoData) {
        // Replace é necessário por esse formato ter uma maior aceitação ex: safari
        const data = new Date(concurso.sdtData.replace(/-/g, "/"));
        datas.push({
          value: concurso.sdtData,
          dataId: concurso.arrConcursoSorteio[0].ConcursoData_ID,
          label: data.toLocaleDateString(),
        });
      }
    }

    return datas;
  }, [currentMoment]);

  const getDayName = (date) => {
    const dateMoment = moment(date);

    const today = moment();
    if (
      dateMoment.date() === today.date() &&
      dateMoment.month() === today.month() &&
      dateMoment.year() === today.year()
    ) {
      return "Hoje";
    }

    const tomorrow = moment().add(1, "day");
    if (
      dateMoment.date() === tomorrow.date() &&
      dateMoment.month() === tomorrow.month() &&
      dateMoment.year() === tomorrow.year()
    ) {
      return "Amanhã";
    }

    const day = dateMoment.day();

    switch (day) {
      case 0:
        return "Domingo";
      case 1:
        return "Segunda";
      case 2:
        return "Terça";
      case 3:
        return "Quarta";
      case 4:
        return "Quinta";
      case 5:
        return "Sexta";
      case 6:
        return "Sábado";
      default:
        return "NaN";
    }
  };

  const checkIfDataIsAvailable = useCallback((selected) => {
    if (selected[0] && typeof selected[0].value === "number") {
      const newSelectedList = selected.filter((sel) =>
        moment(moment(moment().format("YYYY-MM-DD") + " " + sel.label)).isAfter(
          moment()
        )
      );

      handleChange(newSelectedList.map((s) => s.value));
      setSeleted(newSelectedList);
    }
  }, []);

  const handleToggle = (value) => {
    const newSelect = arrDatas.find((d) => d.value === value);

    const newSelectedList = !selected.some((s) => s.value === value)
      ? selected.concat([newSelect])
      : selected.filter((item) => item.value !== newSelect.value);

    setSeleted(newSelectedList);
    handleChange(newSelectedList.map((s) => s.dataId ? {id: s.dataId, date: s.value} : s.value));
  };

  const handleValue = (add) => {
    const newValue = value+add;
    if(newValue >= 0 && newValue <= arrDatas.length){
      setValue((v)=>v+add);
    }
  };

  const handleDates = (newValue) => {
    if(newValue >= 0 && newValue <= arrDatas.length){
      const newSelectedList = arrDatas.slice(0, newValue);

      setSeleted(newSelectedList);
      handleChange(newSelectedList.map((s) => s.dataId ? {id: s.dataId, date: s.value} : s.value));
    }
  };

  useEffect(()=>{
    handleDates(value);
  },[value]);

  return (
    <React.Fragment>
    {arrDatas.length > 0 ?
    <React.Fragment>
      {isTypeDate ?
        <React.Fragment>
          <label>Data do Concurso:</label>
          <div className="data-selector-container tipo-data">
            {arrDatas.map((data) => (
              <button
                key={data.value}
                onClick={() => handleToggle(data.value)}
                className={
                  selected.some((s) => s.value == data.value) ? "selected" : ""
                }
              >
                {isTypeDate && <p>{getDayName(data.value)}</p>}
                {data.label}
              </button>
            ))}
          </div>
        </React.Fragment>
        : allowsContestSelection ?
        <React.Fragment>
          <label>Selecione os Concursos:</label>
          <div className="data-selector-container tipo-data">
            {arrContestTimes.map((data) => (
              <button
                key={data.value}
                onClick={() => handleToggle(data.value)}
                className={
                  selected.some((s) => s.value == data.value) ? "selected" : ""
                }
              >
                {data.label}
              </button>
            ))}
          </div>
        </React.Fragment> 
        :
        <React.Fragment>
          <label>Quantidade de Concursos:</label>
          <div className="data-selector-container">
            <button className="alternative-button btn-primary amount-setter" onClick={()=>{handleValue(-1)}}>-</button>
            <input 
            className="input-date-selector" 
            type="number" 
            defaultValue={0}
            value={value}
            min={0} 
            max={arrDatas.length}
            readOnly={true} />
            <button className="alternative-button btn-primary amount-setter" onClick={()=>{handleValue(1)}}>+</button>
          </div>
        </React.Fragment>
      }
    </React.Fragment>
    :
    <label>Nenhuma data de concurso disponível.</label>
    }
    </React.Fragment>
  );
};

export default DateSelector;



// WEBPACK FOOTER //
// ./src/newDesign/components/date-selector.jsx